import * as API from '../api'
export const FETCH_MEDICATION_CLASSIFICATION = 'FETCH_MEDICATION_CLASSIFICATION'
export const FETCHING_MEDICATION_CLASSIFICATION = 'FETCHING_MEDICATION_CLASSIFICATION'
export const FETCH_MEDICATION_CLASSIFICATION_ERROR = 'FETCH_MEDICATION_CLASSIFICATION_ERROR'
export const FETCH_MEDICATIONS_CLASSIFICATION = 'FETCH_MEDICATIONS_CLASSIFICATION'
export const FETCHING_MEDICATIONS_CLASSIFICATION = 'FETCHING_MEDICATIONS_CLASSIFICATION'
export const FETCH_MEDICATIONS_CLASSIFICATION_ERROR = 'FETCH_MEDICATIONS_CLASSIFICATION_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_MEDICATION_CLASSIFICATION = 'CHANGE_MEDICATION_CLASSIFICATION'
export const DELETE_MEDICATION_CLASSIFICATION = 'DELETE_MEDICATION_CLASSIFICATION'
export const ADD_MEDICATION_CLASSIFICATION = 'ADD_MEDICATION_CLASSIFICATION'
export const EDIT_MEDICATION_CLASSIFICATION = 'EDIT_MEDICATION_CLASSIFICATION'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_MEDICATION_CLASSIFICATION = 'NEW_FORM_MEDICATION_CLASSIFICATION'
export const MEDICATION_CLASSIFICATION_FORM_ERROR = 'MEDICATION_CLASSIFICATION_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}
export const handleChangeMedicationClassification = medicationClassification => {
  return dispatch => {
    dispatch({ type: CHANGE_MEDICATION_CLASSIFICATION, medicationClassification })
  }
}
const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}
export const handleMedicationClassificationError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: MEDICATION_CLASSIFICATION_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)
    default:
      break
  }
}
export const newFormMedicationClassification = medicationClassification => {
  return dispatch => {
    dispatch({ type: NEW_FORM_MEDICATION_CLASSIFICATION })
  }
}
export const setMedicationClassificationFormTouched = medicationClassification => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}
export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}
export const restoreMedicationClassification = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_CLASSIFICATION })
    return API.medicationsClassification
      .restoreMedicationClassification(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_MEDICATION_CLASSIFICATION, medicationClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_CLASSIFICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleMedicationClassificationError(response, dispatch)
        return Promise.reject(response)
      })
  }
}
export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}
export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}
export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}
export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}
export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}
export const fetchMedicationsClassification = options => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_CLASSIFICATION })
    return API.medicationsClassification
      .getMedicationsClassification(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_MEDICATIONS_CLASSIFICATION,
          medicationsClassification: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_CLASSIFICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}
export const deleteMedicationClassification = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_CLASSIFICATION })
    return API.medicationsClassification
      .deleteMedicationClassification(id)
      .then(({ data: medicationClassification }) => {
        dispatch({ type: DELETE_MEDICATION_CLASSIFICATION, medicationClassification })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_CLASSIFICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}
export const addMedicationClassification = medicationClassification => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_CLASSIFICATION })
    dispatch({ type: FETCHING_MEDICATION_CLASSIFICATION })
    return API.medicationsClassification
      .addMedicationClassification(medicationClassification)
      .then(({ data }) => {
        dispatch({ type: ADD_MEDICATION_CLASSIFICATION, medicationClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleMedicationClassificationError(response, dispatch)
        dispatch({
          type: FETCH_MEDICATIONS_CLASSIFICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}
export const editMedicationClassification = medicationClassification => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_CLASSIFICATION })
    dispatch({ type: FETCHING_MEDICATION_CLASSIFICATION })
    return API.medicationsClassification
      .editMedicationClassification(medicationClassification)
      .then(({ data }) => {
        dispatch({ type: EDIT_MEDICATION_CLASSIFICATION, medicationClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_CLASSIFICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleMedicationClassificationError(response, dispatch)
        return Promise.reject(response)
      })
  }
}
export const fetchMedicationClassification = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATION_CLASSIFICATION, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.medicationsClassification
      .getMedicationClassification(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_MEDICATION_CLASSIFICATION, medicationsClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATION_CLASSIFICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/medicationsClassification.js